<template>
    <div>
        <h1>Dynamic Form Page</h1>
        <form @submit.prevent="handleSubmit">
            <div class="formComponent" v-for="(field, key) in formFields" :key="key">
                <label :for="key">{{ field.label }}</label>

                <component v-if="field.component !== 'radio-group' && field.component !== 'checkbox-group'"
                    :is="field.component" v-model="formData[key]" :type="field.type" :name="key"
                    :placeholder="field.placeholder" :options="field.options" class="edit" />

                <div v-else-if="field.component === 'radio-group'" class="radio-group">
                    <div v-for="option in field.options" :key="option.value" class="radio">
                        <label :for="`${key}-${option.value}`">{{ option.label }}</label>
                        <input type="radio" :id="`${key}-${option.value}`" :name="key" :value="option.value"
                            v-model="formData[key]" :true-value="option.value" :false-value="null" />
                    </div>
                </div>

                <div v-else-if="field.component === 'checkbox-group'" class="checkbox-group">
                    <div v-for="option in field.options" :key="option.value" class="checkbox">
                        <label :for="`${key}-${option.value}`">{{ option.label }}</label>
                        <input type="checkbox" :id="`${key}-${option.value}`" :value="option.value"
                            v-model="formData[key]" />
                    </div>
                </div>
            </div>

            <button v-if="isFormModified" type="submit">Save</button>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        initialData: {
            type: Object,
            required: true,
        },
        formFields: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {},
            initialFormData: {},
        };
    },
    computed: {
        isFormModified() {
            return Object.keys(this.formData).some(
                (key) => this.formData[key] !== this.initialFormData[key]
            );
        }
    },
    watch: {
        initialData(newData) {
            console.log(newData);
            this.initializeFormData(newData);
        },
    },
    methods: {
        initializeFormData(data) {
            this.initialFormData = { ...data };
            this.formData = { ...data };
            console.log(this.initialFormData);
        },

        getModifiedFields() {
            const modifiedFields = {};
            Object.keys(this.formData).forEach((key) => {
                if (this.formData[key] !== this.initialFormData[key]) {
                    modifiedFields[key] = this.formData[key];
                }
            });
            return modifiedFields;
        },

        async handleSubmit() {
            const modifiedFields = this.getModifiedFields();
            if (Object.keys(modifiedFields).length > 0) {
                const requestData = {
                    id: this.id,
                    ...modifiedFields,
                };

                try {
                    await this.saveForm(requestData);
                    alert('Form saved successfully!');
                } catch (error) {
                    console.error('Error saving form:', error);
                }
            } else {
                alert('No changes made.');
            }
        },

        async saveForm(data) {
            // Replace with your actual backend logic
            console.log('Sending data to backend:', data);
        },
    },

    mounted() {
        this.initializeFormData(this.initialData);
    },
};
</script>

<style scoped>
.edit {
    --edit-height: 36px;
    height: var(--edit-height);
    cursor: text;
    min-width: 20em;
}

label {
    width: 100px;
    display: inline-block;
}

.formComponent {
    margin-bottom: 4px;
}

textarea.edit {
    resize: none;
    min-height: 100px;
    padding: 5px 8px;
    width: 50em;
}

.checkbox {
    >input {
        margin: 0;
    }
}
</style>